import Icon, {IconProps, IconSize} from '@/components/Icon';
import Text, {TextColor, TextType} from '@/components/Text';
import Button, {ButtonColor, ButtonSize, ButtonType} from '@/components/Button';
import {useIntl} from 'react-intl';
import {EmptyPageSvg, LoadErrorSvg, NoSearchSvg} from '@/icons';
import classNames from 'classnames';
// import {useParams} from 'react-router-dom';
// import {InExistencePlaceholder} from './InExistencePlaceholder';
import styles from './index.module.scss';

export const PlaceholderType = {
    NoData: 1,
    Retry: 2,
    NotFound: 3,
    PersonNotFound: 4,
    Error: 5,
    RefreshErrorPage: 6,
    NoRepository: 7,
    NotFoundEdition: 8,
    Forbidden: 9,
};

interface PlaceholderIconProps extends IconProps {
    hint?: string;
    type?: number;
    onRetry?: () => void;
    className?: string;
}

export default function PlaceholderIcon(props: PlaceholderIconProps) {
    const intl = useIntl();
    // const routeParam: {
    //     groupGuid: string;
    // } = useParams();
    // const {groupGuid} = routeParam || {};

    // const isInDep = groupGuid !== 'pKzJfZczuc';

    const {
        className,
        hint,
        type = PlaceholderType.NoData,
        size = IconSize.Auto,
        onRetry,
        ...iconProps
    } = props;

    function getSvgByType() {
        if (type === PlaceholderType.Retry) {
            return LoadErrorSvg;
        } else if ([
            PlaceholderType.NotFound,
            PlaceholderType.PersonNotFound,
            PlaceholderType.Forbidden
        ].includes(type)) {
            return NoSearchSvg;
        }
        return EmptyPageSvg;
    }

    function getTextByType() {
        if (hint) {
            return hint;
        }
        if (type === PlaceholderType.Retry) {
            return intl.formatMessage({id: 'labelLoadDataError'});
        } else if (type === PlaceholderType.NotFound) {
            return intl.formatMessage({id: 'labelPageNotFound'});
        } else if (type === PlaceholderType.PersonNotFound) {
            return intl.formatMessage({id: 'labelPagePersonNotFound'});
        } else if (type === PlaceholderType.Error) {
            return intl.formatMessage({id: 'labelPageError'});
        } else if (type === PlaceholderType.RefreshErrorPage) {
            return intl.formatMessage({id: 'labelRefreshErrorPage'});
        } else if (type === PlaceholderType.NoRepository) {
            return intl.formatMessage({id: 'labelRepositoryNotFound'});
        } else if (type === PlaceholderType.NotFoundEdition) {
            return intl.formatMessage({id: 'labelEditionNotFound'});
        } else if (type === PlaceholderType.Forbidden) {
            return intl.formatMessage({id: 'labelEditionForbidden'});
        }
        return intl.formatMessage({id: 'labelNoData'});
    }

    // TODO 部门知识库知识库不存在placeholder,先维持一期，视觉稿已出
    // if (isInDep && type === PlaceholderType.NotFound) {
    //     return <InExistencePlaceholder />;
    // }

    return (
        <div className={classNames(styles.root, className)}>
            <div className={styles.content}>
                <Icon size={size} svg={getSvgByType()} {...iconProps} />
                <div className={styles.textArea}>
                    <Text type={TextType.T12} color={TextColor.Info}>
                        {getTextByType()}
                    </Text>
                    {type === PlaceholderType.Retry && (
                        <Button
                            type={ButtonType.Plain}
                            color={ButtonColor.Primary}
                            size={ButtonSize.XS}
                            onClick={onRetry}
                        >
                            {intl.formatMessage({id: 'buttonClickToRetry'})}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}
